import classes from './AssetLabel.module.scss'
import type { ReactNode } from 'react'
import { HiOutlineDesktopComputer } from 'react-icons/hi'
import {
  TestCaseTag,
  TestConfigTag,
  RequirementGroup,
  Requirements,
  TestTools,
  CustomScriptsLayer,
  WebhookNotificationIcon,
  SutTag,
  Models,
  Suites
} from '../Icons/Icons'
import Color from '../Color/Color'
import {
  Paragraph,
  TrackerBadge
} from '../..'
import type { SpaceAssetsLabels } from '../types'

const assetIconMap: Partial<Record<SpaceAssetsLabels, ReactNode>> = {
  Models: <Models size='16' />,
  Suites: <Suites size='16' />,
  'Test case tags': <TestCaseTag size='16' />,
  'Test config tags': <TestConfigTag size='16' />,
  SUTs: (
    <Color variant='theme-filter-icon'>
      <HiOutlineDesktopComputer
        aria-hidden
        size='16'
      />
    </Color>
  ),
  'SUT tags': <SutTag size='16' />,
  'Requirement groups': <RequirementGroup size='16' />,
  Requirements: <Requirements size='16' />,
  'Test mgmt tools': <TestTools size='16' />,
  Webhooks: <WebhookNotificationIcon size='16' />,
  'Custom scripts': <CustomScriptsLayer size='16' />
}

export interface Props {
  label: SpaceAssetsLabels
  badge?: number
  badgeVariant?: 'error' | 'warning'
  isAlwaysVisible?: boolean
}

const AssetLabel = ({
  label,
  badge,
  badgeVariant = 'warning',
  isAlwaysVisible = false
}: Props) => {
  const hasBadge = badge !== undefined && badge !== 0

  return (
    (isAlwaysVisible || hasBadge) &&
      <div className={classes.AssetLabel}>
        <span className={classes.AssetIcon}>
          {assetIconMap[label]}
        </span>
        <span className={classes.AssetText}>
          <Paragraph>
            <strong>
              {label}
            </strong>
          </Paragraph>
        </span>
        {
          hasBadge && (
            <TrackerBadge
              counter={badge}
              variant={badgeVariant}
            />
          )
        }
      </div>
  )
}

export default AssetLabel
